import { library } from '@fortawesome/fontawesome-svg-core'

import { 
	faArrowsAlt,
	faArrowsAltH,
	faAngleDoubleLeft,
	faAngleLeft,
	faAngleRight,
	faAngleDown,
	faAngleDoubleRight,
	faCalculator,
	faCaretDown,
	faCaretUp,
	faCaretRight,
	faChartLine,
	faCircle,
	faCircleNotch,
	faCheck,
	faChevronUp,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faCrop,
	faCompass,
	faCogs,
	faDownload,
	faDrawPolygon,
	faEraser,
	faExpand,
	faExclamationTriangle,
	faFile,
	faFilter,
	faFileDownload,
	faFileUpload,
	faFont,
	faHourglassStart,
	faInfoCircle,
	faPlus,
	faPlusCircle,
	faLayerGroup,
	faListUl,
	faLocationArrow,
	faMapMarker,
	faMapMarkerAlt,
	faMapPin,
	faMinus,
	faMinusCircle,
	faMousePointer,
	faObjectGroup,
	faPrint,
	faPalette,
	faPencilAlt,
	faRoute,
	faSearch,
	faSquare,
	faSync,
	faTable,
	faTrashAlt,
	faTimes,
	faWrench
} from '@fortawesome/pro-solid-svg-icons'


library.add(
	faArrowsAlt,
	faArrowsAltH,
	faAngleDoubleLeft,
	faAngleLeft,
	faAngleRight,
	faAngleDown,
	faAngleDoubleRight,
	faCalculator,
	faCaretDown,
	faCaretUp,
	faCaretRight,
	faChartLine,
	faCircle,
	faCircleNotch,
	faCheck,
	faChevronUp,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faCrop,
	faCompass,
	faCogs,
	faDownload,
	faDrawPolygon,
	faEraser,
	faExpand,
	faExclamationTriangle,
	faFile,
	faFilter,
	faFileDownload,
	faFileUpload,
	faFont,
	faHourglassStart,
	faInfoCircle,
	faPlus,
	faPlusCircle,
	faLayerGroup,
	faListUl,
	faLocationArrow,
	faMapMarker,
	faMapMarkerAlt,
	faMapPin,
	faMinus,
	faMinusCircle,
	faMousePointer,
	faObjectGroup,
	faPrint,
	faPalette,
	faPencilAlt,
	faRoute,
	faSearch,
	faSquare,
	faSync,
	faTable,
	faTrashAlt,
	faTimes,
	faWrench
);